import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    try {
      await navigator.clipboard.writeText(text)
      this.showFeedback("コピーしました")
    } catch {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
      this.showFeedback("コピーしました")
    } catch {
      this.showFeedback("コピーに失敗しました")
    }
    document.body.removeChild(textarea)
  }

  showFeedback(message) {
    if (!this.hasButtonTarget) return

    const originalText = this.buttonTarget.textContent
    this.buttonTarget.textContent = message
    setTimeout(() => {
      this.buttonTarget.textContent = originalText
    }, 2000)
  }
}
